import { createRouteHelpers } from "../../shared/utils/createRouteHelpers";

export const PATH_PAYABLES = "/member/invoices/payables";
export const PARAMETER_TAB = "tab";
export const PARAMETER_PAYABLE_ID = "payableId";

export const PAYABLES_TAB_SLUGS = [
  "dashboard",
  "to-preapprove",
  "to-approve",
  "scheduled",
  "paid",
  "payroll-runs",
  "all",
  "deductions",
  "bulk-uploaded"
] as const;

export type PayablesTabSlug = (typeof PAYABLES_TAB_SLUGS)[number];

export const PATH_PAYABLES_TAB = `${PATH_PAYABLES}/:${PARAMETER_TAB}`;
export const PATH_PAYABLES_DETAILS = `${PATH_PAYABLES_TAB}/:${PARAMETER_PAYABLE_ID}`;
export const PATH_PAYABLES_CREATE = `${PATH_PAYABLES}/create`;
export const PATH_PAYABLES_EDIT = `${PATH_PAYABLES}/:${PARAMETER_PAYABLE_ID}/edit`;
export const PATH_PAYABLES_DRAFT = `${PATH_PAYABLES}/draft`;
export const PATH_PAYABLES_DISPUTED = `${PATH_PAYABLES}/disputed`;
export const PATH_PAYABLES_PAYROLL_RUNS = `${PATH_PAYABLES}/payroll-runs`;
export const PATH_PAYABLES_PAYROLL_RUN = `${PATH_PAYABLES}/payroll-runs/:payrollRunId`;
export const PATH_PAYABLES_OFF_CYCLE_PAYROLL = `${PATH_PAYABLES}/off-cycle-payroll`;
export const PATH_PAYABLES_DEDUCTIONS = `${PATH_PAYABLES}/deductions`;

export const routeHelpersPayables = createRouteHelpers(PATH_PAYABLES);
export const routeHelpersPayablesTab = createRouteHelpers<{
  tab: PayablesTabSlug;
}>(PATH_PAYABLES_TAB);
export const routeHelpersPayablesDetails = createRouteHelpers<{
  tab: PayablesTabSlug;
  payableId: string;
}>(PATH_PAYABLES_DETAILS);
export const routeHelpersPayablesPayrollRun = createRouteHelpers<{
  payrollRunId: string;
}>(PATH_PAYABLES_PAYROLL_RUN);
